<div class="form-group has-feedback">
  <input
    type="password"
    class="form-control"
    placeholder="Password"
    [formControl]="control"
    (blur)="onPasswordBlur()"
  />
  <span class="glyphicon glyphicon-lock form-control-feedback"></span>
</div>
